module.exports = __webpack_public_path__ + "static/media/k.b815a5ae.svg";